import Component from '@glimmer/component';
import { service } from '@ember/service';
import config from 'frontend/config/environment';
import type SessionService from 'frontend/services/session';

interface ApplicantAgreementArgs {
  isProfile?: boolean;
  disabled?: boolean;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class ApplicantAgreement extends Component<ApplicantAgreementArgs> {
  config = config;
  @service declare session: SessionService;

  get isNotAuthenticated() {
    return !this.session.isAuthenticated;
  }

  get termsUrl() {
    return `${this.config.frontUrl}/mentions-legales`;
  }
}
